import { createApi } from "@reduxjs/toolkit/query/react";
import {
  SalesReturnSearchResult,
  SalesReturnSearch,
  SalesReturnSummaryResult,
} from "@/types/meesho/meeshoSalesReturn";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";

export const MeeshoSalesReturnApi = createApi({
  reducerPath: "MeeshoSalesReturnApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["meeshosalesReturn"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    uploadSalesReturn: builder.mutation({
      query: ({ formData }) => ({
        url: `/salesreturn/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["meeshosalesReturn"],
    }),
    searchReturn: builder.query<SalesReturnSearchResult, SalesReturnSearch>({
      query: (input) => {
        return {
          url: `/salesreturn/sales_return_search`,
          method: "POST",
          body: { ...input, export: false },
        };
      },
      providesTags: ["meeshosalesReturn"],
    }),
    exportSalesReturn: builder.mutation<Blob, SalesReturnSearch>({
      query: (input) => ({
        url: `/salesreturn/sales_return_search`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryOrdesSalesReturn: builder.query<
      SalesReturnSummaryResult,
      SalesReturnSearch
    >({
      query: (input) => ({
        url: `/salesreturn/sales_return_summary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["meeshosalesReturn"],
    }),
    deleteSalesReturns: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/salesreturn/return_delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["meeshosalesReturn"],
    }),
  }),
});

export const {
  useUploadSalesReturnMutation,
  useSearchReturnQuery,
  useExportSalesReturnMutation,
  useLazySearchReturnQuery,
  useSummaryOrdesSalesReturnQuery,
  useDeleteSalesReturnsMutation,
} = MeeshoSalesReturnApi;
